/**
 * Typescript常量声明
 * const声明一个只读的常量，大写，具体使用含义单词拼接
 * 后续可以考虑拆分为多个文件及模块 HTTP/NAV/ENUM/LABEL/ERROR
 * */
import { locale } from "../locale/index";

// *枚举,常量文字都放这里
// export const HTTP_STATUS_MSG_404 = "页面走丢了";
export const HTTP_STATUS_MSG_401 = locale("token_expired");
export const HTTP_STATUS_MSG_5XX = locale("network_error");
export const HTTP_STATUS_TITLE_ERROR = locale("request_error");
export const HTTP_STATUS_TITLE_5XX = locale("server_error");
// pdf 组件
export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const VIEWPORT_RATIO = 0.98;

//周报
export const WEEKLY = locale("weekly");
export const WEEKLY_SEE = locale("read_weekly");
export const WEEKLY_WRITE = locale("write_weekly");

//日报
export const DAILY = locale("daily");
export const DAILY_SEE = locale("read_daily");
export const DAILY_WRITE = locale("write_daily");

// 按钮文本
export const POST_OKR = locale("create_OKR");
// 导航
export const MY_INFO = "OKR";

export const MY_ORG = "我的组织";
export const MY_ORG_DATA = "我的组织";

export const MY_OKR = locale("my_okr");
export const GROUP_OKR = locale("group_OKR");
export const HISTORY_VIEW = "我的小组";
export const MY_FOCUS = locale("my_focus");
export const MY_COLLECT = locale("my_favorites");
export const TEAM_WORK = locale("collaborative_OKR");
export const MY_MARK = locale("benchmark_OKR");
export const MY_TOP_SAME_LEVEL = locale("superiors_and_peers");
export const MY_SUBORDINATE = locale("my_subordinates");

export const KPI = "KPI";
export const KPI_DATA = "KPI数据管理";

export const DATA_WATCH = "数据展示";
export const DATA_USAGE = "部门数据";
export const DATA_PERSON = "人员数据";
export const DATA_WEEK = "周报数据";
export const DATA_ACTIVATION = "用户活跃";

export const E360 = "360°调研";
export const NEW360 = "360°测评";

export const WORKCODE_LENGTH = 6;
export const PAGINATION_SIZE_ENUM = [20, 50, 100, 200];
export const NEW_LEVELS = {
  "1.1": ["P1"],
  "1.2": ["P2"],
  "1.3": ["P3"],
  "2.1": ["P4", "M2.1"],
  "2.2": ["P5", "M2.2"],
  "2.3": ["P6", "M2.3"],
  "3.1": ["P7", "M3.1"],
  "3.2": ["P8", "M3.2"],
  "3.3": ["P9", "M3.3"],
  "4.1": ["P10", "M4.1"],
  "4.2": ["P11", "M4.2"],
  "4.3": ["P12", "P13", "M4.3"],
  "5.1": ["P14", "M5.1"],
  "5.2": ["P15", "M5.2"],
  "5.3": ["P16", "M5.3"],
  "6.1": ["M6.1"],
  "6.2": ["M6.2"],
  "6.3": ["M6.3"],
  "7": ["M6.1", "M6.2", "M6.3", "M7"],
};
export const AVAILABILITY_ENUM = {
  "0": "启用",
  "1": "禁用",
};
// 数据范围枚举, 0-所有, 1- 根据权限
export const DATA_SCOPE_ENUM = {
  ALL: 0,
  WITH_PERMISSION: 1,
};

export const LOGOUT = "退出";
export const FORM_ROLE_NAME = "角色名称";

export const BTN_CANCLE = "取 消";
export const BTN_CONFIRM = "确 定";
export const ROLE_ADD = "添加角色";
export const ROLE_MODIFY = "修改角色";

export const PERMISSIONS_ENUM = {
  ROLE_MANAGER: 1001, //角色管理
  ADMIN_MANAGER: 1002, //管理员管理
  LEVEL_PERMISSION: 2201, //职级权限
};
export const FORM_ENTERPRISE_EMAIL = "企业邮箱";
export const USER_ADD = "添加用户";
export const USER_MODIFY = "修改用户";
export const FORM_NAME = "姓名";
export const FORM_ROLE = "角色";
export const FORM_DEPARTMENT = "部门";

export const DRAG_FILE = "将文件拖到此处，或";
export const CLICK_TO_UPLOAD = "点击上传";
export const DOWNLOAD_EXCEL_TEMPLATE = "EXCEL表格模板下载";
export const LEVEL = "职级";
export const EMPLYEE_TYPE = "员工类别";
export const REMARK = "备注";
export const WORKCODE = "员工编号";
export const ABSENCE_REASON = "缺席原因";
export const CREATOR = "创建人";
export const SERIAL_NUMBER = "编号";
export const ACTIVITY_TYPE = "活动类型";
export const ACTIVITY_NAME = "活动名称";
export const ACTIVITY_LOCATION = "活动地点";
export const MANAGER = "管理人";

// 反馈URL
export const FEED_URL = "https://feedback.100tal.com";
